import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/HomeView.vue";
import store from "../store/index";

const routes = [
  /* inicio vistas antes de registrarse o iniciar sesion */
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/signup",
    name: "registro",
    component: () =>
      import(
        /* webpackChunkName: "formulario_registro" */ "../views/FormularioRegistroView.vue"
      ),
  },
  {
    path: "/login",
    name: "iniciar-sesion",
    component: () =>
      import(
        /* webpackChunkName: "formualario_sesion" */ "../views/FormularioSesionView.vue"
      ),
  },
  {
    path: "/blog",
    name: "blog",
    component: () =>
      import(/* webpackChunkName "blog"*/ "../views/BlogView.vue"),
  },
  {
    path: "/blog/articulo/:id",
    name: "articuloHomeId",
    component: () =>
      import(
        /* webpackChunkName: "leer_articulo" */ "../views/LeerArticuloView.vue"
      ),
    props: true,
  },
  {
    path: "/planes",
    name: "planes",
    component: () =>
      import(/* webpackChunkName "planes"*/ "../views/PlanesView.vue"),
  },
  {
    path: "/comunidad",
    name: "proyectos-comunidad",
    component: () =>
      import(
        /* webpackChunkName "proyectos-comunidad"*/ "../views/ComunidadView.vue"
      ),
  },
  {
    path: "/comunidad/proyecto/:id",
    name: "proyectosComunidadHomeId",
    component: () =>
      import(
        /* webpackChunkName: "proyectos_comunidad" */ "../views/ProyectosComunidadView.vue"
      ),
    props: true,
  },
  {
    path: "/desafios",
    name: "desafios",
    component: () =>
      import(/* webpackChunkName "desafios"*/ "../views/DesafiosView.vue"),
  },
  /* PAGINAS DEL FOOTER */
  {
    path: "/sobre-nosotros",
    name: "sobre-nosotros",
    component: () =>
      import(
        /* webpackChunkName "sobren nosotros"*/ "../views/SobreNosotrosView.vue"
      ),
  },
  {
    path: "/nuestra-marca",
    name: "nuestra-marca",
    component: () =>
      import(
        /* webpackChunkName "nuestra marca"*/ "../views/NuestraMarcaView.vue"
      ),
  },
  {
    path: "/como-funciona-iquela",
    name: "como-funciona-iquela",
    component: () =>
      import(
        /* webpackChunkName "como funciona iquela"*/ "../views/ComoFuncionaIquelaView.vue"
      ),
  },
  {
    path: "/historias-de-exito",
    name: "historias-de-exito",
    component: () =>
      import(
        /* webpackChunkName "historias de exito"*/ "../views/HistoriasView.vue"
      ),
  },

  {
    path: "/preguntas-frecuentes",
    name: "preguntas-frecuentes",
    component: () =>
      import(
        /* webpackChunkName "preguntas-frecuentes"*/ "../views/PreguntasFrecuentesView.vue"
      ),
  },
  {
    path: "/aviso-de-privacidad",
    name: "politicas-de-privacidad",
    component: () =>
      import(
        /* webpackChunkName "politicas-de-privacidad"*/ "../views/PoliticasPrivacidadView.vue"
      ),
  },
  {
    path: "/condiciones-de-uso",
    name: "terminos-y-condiciones",
    component: () =>
      import(
        /* webpackChunkName "terminos-y-condiciones"*/ "../views/TerminosYCondicionesView.vue"
      ),
  },

  /* PAGINAS QUE REQUIEREN AUTENTICACION*/
  {
    path: "/dashboard",
    name: "dashboard",
    component: () =>
      import(/* webpackChunkName: "dashboardI" */ "../views/DashboardView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/proyectos",
    name: "proyectos",
    component: () =>
      import(/* webpackChunkName: "proyectos" */ "../views/ProyectosView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/proyectos/proyecto/:id",
    name: "proyectoId",
    component: () =>
      import(
        /* webpackChunkName: "proyecto_requerimientos" */ "../views/ProyectoRequerimientoView.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/comunidad",
    name: "comunidadDashboard",
    component: () =>
      import(
        /* webpackChunkName: "comunidad" */ "../views/ComunidadDahsboardView.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/comunidad/proyecto/:id",
    name: "proyectoComunidadId",
    component: () =>
      import(
        /* webpackChunkName: "proyectos_comunidad" */ "../views/ProyectosComunidadDashboardView.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/blog",
    name: "blogDashboard",
    component: () =>
      import(
        /* webpackChunkName: "BlogDashboard" */ "../views/BlogDashboardView.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/blog/articulo/:id",
    name: "articuloId",
    component: () =>
      import(
        /* webpackChunkName: "leer_articulo" */ "../views/LeerArticuloDashaboardView.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/planes",
    name: "planesDashboard",
    component: () =>
      import(/* webpackChunkName: "Premium" */ "../views/PremiumView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/perfil",
    name: "perfil",
    component: () =>
      import(/* webpackChunkName: "pefil" */ "../views/PerfilView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/editar",
    name: "editar-perfil",
    component: () =>
      import(
        /* webpackChunkName: "editar-pefil" */ "../views/EditarPerfilView.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/perfil/:nombre/proyecto/:id",
    name: "tuProyectoId",
    component: () =>
      import(
        /* webpackChunkName: "proyecto_usuario" */ "../views/ProyectoUsuarioView.vue"
      ),
    meta: {
      requiresAuth: false, // por defecto, la ruta no requiere autenticación
      allowAnonymous: true, // se permite el acceso a usuarios no autenticados
    },
    props: true,
  },
  {
    path: "/publicar/proyecto",
    name: "subir-proyecto",
    component: () =>
      import(
        /* webpackChunkName: "subir_proyecto" */ "../views/SubirProyectoView.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/revision",
    name: "revision-proyecto",
    component: () =>
      import(
        /* webpackChunkName: "revision_proyecto" */ "../views/SubirRevisionView.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/notificacion/:id",
    name: "notificacion",
    component: () =>
      import(
        /* webpackChunkName: "notificacion" */ "../views/NotificacionView.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/seguir-proyecto/:id",
    name: "seguimiento",
    component: () =>
      import(
        /* webpackChunkName: "notificacion" */ "../views/SeguirProyectoUsuarioView.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    props:true,
  },
  /* pagina 404 */
  {
    path: "/404",
    name: "PageNotExist",
    component: () =>
      import(/* webpackChunkName: "editar-pefil" */ "../views/404View.vue"),
  },
  {
    path: "/:catchAll(.*)", // Unrecognized path automatically matches 404
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const allowAnonymous = to.matched.some(
    (record) => record.meta.allowAnonymous
  );

  if (requiresAuth && !(await store.dispatch("autenticacion/getCurrentUser"))) {
    next({ name: "home" });
  } else if (
    !requiresAuth &&
    !allowAnonymous &&
    (await store.dispatch("autenticacion/getCurrentUser"))
  ) {
    next({ name: "dashboard" });
  } else {
    next();
  }
});
export default router;
